import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { UserPlus, Search, Loader2, FileCheck } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { PartnerCandidateDialog } from './PartnerCandidateDialog';

export const PartnerCandidatesTab = ({ onChanged }) => {
  const [list, setList] = useState(null);
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);

  const load = (term) => partnerPortalAPI.candidates(term || undefined)
    .then((r) => setList(r.data)).catch(() => toast.error('Erro ao carregar candidatos'));
  useEffect(() => { load(); }, []);

  return (
    <Card data-testid="partner-candidates-tab">
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle>Meus Candidatos</CardTitle>
          <CardDescription>Pessoas vinculadas à sua entidade (pelo convite, pela escolha no app ou cadastradas por você).</CardDescription>
        </div>
        <Button onClick={() => setOpen(true)} className="bg-amber-500 hover:bg-amber-600 shrink-0" data-testid="partner-add-candidate">
          <UserPlus className="w-4 h-4 mr-2" />Cadastrar pessoa
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        <form className="relative max-w-sm" onSubmit={(e) => { e.preventDefault(); load(q); }}>
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nome" className="pl-9" data-testid="partner-candidates-search" />
        </form>
        {!list ? <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" /> : list.length === 0 ? (
          <p className="text-sm text-slate-500 py-6 text-center" data-testid="partner-candidates-empty">Nenhum candidato vinculado ainda. Cadastre pessoas ou compartilhe seu convite.</p>
        ) : (
          <div className="divide-y rounded-lg border" data-testid="partner-candidates-list">
            {list.map((c) => (
              <div key={c.id} className="p-3 flex items-center justify-between gap-3" data-testid={`partner-candidate-${c.id}`}>
                <div className="min-w-0">
                  <p className="font-medium text-slate-900 truncate">{c.nome}</p>
                  <p className="text-xs text-slate-500">{c.cpf_mascarado} · {c.telefone || 'sem telefone'} · {c.cidade || '—'}{c.estado ? `/${c.estado}` : ''}</p>
                  {c.cargos?.length > 0 && <p className="text-xs text-slate-600 truncate">{c.cargos.join(', ')}</p>}
                </div>
                <div className="flex gap-1 shrink-0">
                  {c.tem_curriculo && <Badge variant="outline" className="gap-1"><FileCheck className="w-3 h-3" />Currículo</Badge>}
                  {c.cadastrado_por_partner && <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">Cadastrado pela entidade</Badge>}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
      <PartnerCandidateDialog open={open} onClose={() => setOpen(false)} onSaved={() => { load(q); onChanged?.(); }} />
    </Card>
  );
};
